/** Header component reducer actions */
export const HEADER_ACTIONS = {
    LOADING : "loading",
    ERROR: "error",
    SUCCESS: "success",
    RESET: "reset",
}

